export function getUserErrorMessages(variables: any) {
    return {
        'Unauthorized to active status of user': variables.notAuthorized + variables.toChangeUserState,
        'User not found': variables.User + variables.notFound,
        'Unauthorized to force change password of user': variables.notAuthorized + variables.toForceChangeUserPass,
        "Unauthorized to register new users": variables.notAuthorized + variables.toRegisterUsers,
        "Email is already in use": variables.mailAlreadyExists,
        'Forbidden to edit users': variables.notAuthorized + variables.toEditUsers,
        'First name is required': variables.invalidName,
        'First name contains invalid characters': variables.invalidCharsInName,
        'Last name is required': variables.invalidLastName,
        'Lastname is required': variables.invalidLastName,
        'Last name contains invalid characters': variables.invalidCharsInLastName,
        'Invalid JWT token': variables.sessionExpired,
        "Forbidden to search users": variables.unauthorizedToSearchUsers,
        'Email is required': variables.mailRequired,
        "Invalid email format": variables.invalidEmailFormat,
        "Invalid email domain": variables.invalidEmailDomain
    };
} 